import mitt from 'mitt';
import { Device, Call } from '@twilio/voice-sdk';
import type { ReservedCallData } from '@/models/callLog';
import type { Caller } from '@/models/caller';

type Payload = {
  code: string;
  message: string;
  subject: string;
  data: any;
};

export type Events = {
  onTwilioReady: Device;
  onTwilioError: any;
  onTwilioIncoming: Call;
  'populate-operator-performance-calls': { operatorId: string; startDate: string; endDate: string };
  'reset-page': void;
  'reload-transactions': any;
  'refresh-right-panel': any;
  'refresh-credit-card': any;
  'update-custom-locations': any;
  'stripe:create-token': any;
  'stripe:setupIntent-confirmed': string;
  'open-right-panel-section': string;
  'add-payment-method': void;
  'reload-credit-cards': void;
  'set-needlove-to-right-panel': { id: string; formId: number; phoneNumber: string };
  'on-outbound-call-queue': { id: number; queuePhoneNumber: string };
  'move-outbound-call-queue': void;
  'reset-registration-data': void;
  'follow-up-requests-changed': void;
  'live-call-call-type-updated': void;
  'update-customer-operator-notes': { operatorNote: string };
  'reset-first-ride-setup-form': void;
  'coaching-assignment-created': void;
  'set-client-stripe-status': Payload;
  'reserved-outbound-call': ReservedCallData;
  'reserved-outbound-call-cancelled': void;
  'follow-up-call-started': number;
  'ride-activities-loading': boolean;
  /** Fills the right panel dialer with a number and expands it, without starting the call */
  'dial-phone-number': string;
  'join-conference-call': { conferenceFriendlyName: string; action: 'dial' | 'coach' };
  'update-connected-customer': Caller;
};

export default mitt<Events>();
